
import {WdiPanel} from "@/components/WdiControls/WdiPanel";
import {WdiCardTitle, WdiInput} from "@/components/WdiControls";
import {Enum} from "@/enums/system";
import {Col, Form, Row, Checkbox} from "antd";
import React from "react";
import {WdiFileList} from "@/components/WdiControls/WdiFileUpload";
import {OaProgramViewApp} from "@/pages/policy/ProductPolicyApply/components/OaProgramViewApp";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

type ProductPolicyHeaderProps = {
  formRef: React.MutableRefObject<any>;
};

const ProductPolicyBasicApprovalPanel: React.FC<ProductPolicyHeaderProps> = (props: ProductPolicyHeaderProps) => {
  return (<>
    <WdiPanel collapsed={true} title={ <WdiCardTitle iconType={ Enum.IconType.BASE_INFO} title={ '基本信息' }/> }>
      <Row gutter={ [16, 0] }>
        <Col className="gutter-row" span={ 8 } key="policyName">
          <Form.Item name="policyName" label="政策名称" rules={ [{ required: false, message: '政策名称不能为空!' }] }>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="bohqId">
          <Form.Item name="bohqName" label="预算归属" rules={[{required: false, message: '预算归属不能为空!'}]}>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="bohqRebateTypeId">
          <Form.Item name="bohqRebateTypeName" label="返利预算归属方式" rules={[{required: false, message: '返利预算归属方式不能为空!'}]}>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="policyDate">
          <Form.Item name="policyDate" label="政策期间" rules={ [{ required: false, message: '政策期间不能为空!' }] }>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="boIds">
          <Form.Item name="boNames" label="使用部门范围" rules={ [{ required: false, message: '使用部门范围不能为空!' }] }>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="custTypeIds">
          <Form.Item name="custTypeNames" label="客户分类" rules={[{required: false, message: '客户分类不能为空!'}]}>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="policyCategoryId">
          <Form.Item name="policyCategoryName" label="政策类别" rules={[{required: false, message: '政策类别不能为空!'}]}>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="ecIds">
          <Form.Item name="ecNames" label="费用项" rules={ [{ required: false, message: '费用项不能为空!' }] }>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="oaFormNo">
          <Form.Item name="oaForms" label="OA方案" rules={[{required: false, message: 'OA方案不能为空!'}]}>
            <OaProgramViewApp/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="isAutoAppend">
          <Form.Item name="isAutoAppend" label="追溯计算(已生成过返利则无效)" valuePropName="checked">
            <Checkbox disabled/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="modifiedDate">
          <Form.Item name="modifiedDate" label="修改日期" rules={ [{ required: false, message: '政策期间不能为空!' }] }>
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={ 4 } key="modifiedUserName">
          <Form.Item name="modifiedUserName" label="修改人">
            <WdiInput readOnly />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key={'isActive'}>
          <Form.Item name="isActive" label="是否激活" valuePropName="checked">
            <Checkbox disabled={true}/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={ [16, 0] }>
        <Col className="gutter-row" span={16}>
          <Form.Item
            name="remark"
            label="政策说明"
          >
            <WdiEditor readOnly={true}/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={8}>
          <Form.Item
            name="fileInfo"
            label="附件"
            valuePropName="fileList"
            getValueFromEvent={(e: any) => {
              return e.fileList || [];
            }}
          >
            <WdiFileList/>
          </Form.Item>
        </Col>
      </Row>
    </WdiPanel>
  </>)
}

export default ProductPolicyBasicApprovalPanel;
